const config = {
    basePath: process.env.NEXT_PUBLIC_BASE_PATH ?? '/arbeid/registrering',
};

export default config;
